import styled from "styled-components";
import { typeStyle } from "@m/alchemy-theme";
export const MonthName = styled.h2 `
  display: block;
  text-align: center;
  ${typeStyle("headerS")};
  margin: 6px 0;
`;
export const MonthNav = styled.div `
  left: 0;
  position: absolute;
  right: 0;
  top: 0;

  && {
    button {
      padding: 0;
      height: 32px;
      width: 32px;
      top: 0;
      flex-shrink: 0;
      border-radius: 16px;
      overflow: hidden;
      position: absolute;

      &:nth-child(2) {
        right: 0;
        left: auto;
      }
    }
  }
`;
